import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

const ErrorPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { message } = location.state || {};

    const handleGoBack = () => {
        navigate(-1); // Navigate to the previous page
    };

    const handleGoHome = () => {
        navigate('/'); // Navigate to the home page
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                height: '100vh',
                textAlign: 'center',
                padding: 2,
                paddingTop: '10vh',
            }}
        >
            <Typography variant="h2" component="h1" gutterBottom>
                Oops!
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
                Something went wrong.
            </Typography>
            {message && (
                <Typography variant="body1" gutterBottom>
                    {message}
                </Typography>
            )}
            <Box sx={{ marginTop: 4 }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleGoBack}
                    sx={{ marginRight: 2 }}
                >
                    Go Back
                </Button>
                <Button variant="outlined" color="primary" onClick={handleGoHome}>
                    Go to Home
                </Button>
            </Box>
        </Box>
    );
};

export default ErrorPage;